import { render, staticRenderFns } from "./ElChoices.vue?vue&type=template&id=0e82f5c4&scoped=true"
import script from "./ElChoices.vue?vue&type=script&lang=js"
export * from "./ElChoices.vue?vue&type=script&lang=js"
import style0 from "./ElChoices.vue?vue&type=style&index=0&id=0e82f5c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82f5c4",
  null
  
)

export default component.exports